export const initialDeliveryLocation = {
  locationId: '',
  type: 1,
  name: '',
  shortName: '',
  geoCoord: {
    latitude: 0,
    longitude: 0
  },
  phoneNumber: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  addressTown: '',
  addressPostCode: '',
  addressCounty: '',
  addressCountry: '',
  contactEmail: ''
};

export const initialCollectionLocation = {
  locationId: '',
  type: null,
  name: '',
  shortName: '',
  geoCoord: {
    latitude: null,
    longitude: null
  },
  phoneNumber: '',
  addressLine1: '',
  addressLine2: '',
  addressLine3: '',
  addressTown: '',
  addressPostCode: '',
  addressCounty: '',
  addressCountry: '',
  contactEmail: ''
};
